import React from 'react';
import { CircleDotIcon } from 'lucide-react';
const links = [['Terms & Conditions', '#terms'], ['Privacy Policy', '#privacy'], ['Contact', '#contact']];
export function Footer() {
  return <footer className="bg-tr-navy-deep px-5 py-12 text-center" data-id="element-89" data-mp="32onigxc1ze6b">
      <div className="mx-auto max-w-container" data-id="element-90" data-mp="32m1ch24t96q7">
        <p className="flex items-center justify-center gap-2 text-base font-bold uppercase tracking-[0.14em] text-white" data-id="element-91" data-mp="36qhg0wqyc229">
          <CircleDotIcon className="h-4 w-4 text-[#D8F35B]" aria-hidden="true" data-id="element-92" data-mp="3uftn9r2py01x" />
          Tennis Ready
        </p>
        <p className="mt-3 text-[13px] text-white/55" data-id="element-93" data-mp="3levgx24t5gg6">
          The complete tennis curriculum for coaches and teachers
        </p>
        <nav aria-label="Footer" className="mt-7 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-[13px] text-white/70" data-id="element-94" data-mp="3qc3zh3tvbmhy">
          {links.map(([label, href]) => <a key={label} href={href} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-95" data-mp="2ezut5jpxs4ko">
              {label}
            </a>)}
        </nav>
        <p className="mt-8 text-[11px] text-white/40" data-id="element-96" data-mp="3gctpaoe58prc">
          © 2026 Tennis Ready — All rights reserved.
        </p>
      </div>
    </footer>;
}